import { Card, Col } from 'reactstrap'
import { BasicInputGroup } from '../../../../../Utils/Constants'
import { basicInputGroupData } from '../../../../../Data/Forms/FormsControl/InputGroup/InputGroup'
import BasicInputGroupsCardBody from './BasicInputGroupsCardBody'
import BasicInputGroupsCardFooter from './BasicInputGroupsCardFooter'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const BasicInputGroups = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={BasicInputGroup} span={basicInputGroupData} />
        <BasicInputGroupsCardBody/>
        <BasicInputGroupsCardFooter />
      </Card>
    </Col>
  )
}

export default BasicInputGroups